export const isMobileDevice = () => {
    return /mobile|android|iphone|ipad|phone/i.test(navigator.userAgent)
}